import { FluidImage } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './HeroFloatingItems.module.scss';

type FloatingItem = Readonly<{
    name: string;
    className: string;
}>;

export type LogoItem = Readonly<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- i18next requires dynamic translation keys to be cast as any
    src: any;
    name: string;
    className: string;
}>;

export type HeroSlide = Readonly<{
    src: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- i18next requires dynamic translation keys to be cast as any
    alt: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- i18next requires dynamic translation keys to be cast as any
    hero: any;
    heroAspectRatio: number;
    floatingItems: readonly FloatingItem[];
    logoItem: LogoItem;
    item2Index: number;
}>;

export type HeroSlides = Readonly<{
    slide1: HeroSlide;
    slide2: HeroSlide;
    slide3: HeroSlide;
}>;

type HeroFloatingItemsProps = Readonly<{
    item: FloatingItem;
    isVisible: boolean;
    isZoomingOut: boolean;
    isPaused: boolean;
    src: string;
}>;

const HeroFloatingItems = ({
    item,
    isVisible,
    isZoomingOut,
    isPaused,
    src,
}: HeroFloatingItemsProps) => {
    const classNames = item.className.split(' ').filter(Boolean);

    const mappedClasses = classNames
        .map((className) => styles[className as keyof typeof styles] as string | undefined)
        .filter(Boolean)
        .join(' ');

    useStyles(stylesheet);

    if (!isVisible) {
        return null;
    }

    return (
        <FluidImage
            src={src}
            className={`${mappedClasses} ${isZoomingOut ? styles.zoomOut : styles.zoomIn} ${isPaused ? styles.pauseFloating : ''}`}
            alt=""
        />
    );
};

export default HeroFloatingItems;
